import React, { Component } from 'react';

type SearchBarProps = {
    initialKeyword?: string,
    searchButtonText: string,
    placeholderText: string,
    onSearch: (keyword: string) => void
}

type SearchBarState = {
    keywords: string
}

export default class SearchBar extends Component<SearchBarProps, SearchBarState> {
    constructor(props: SearchBarProps) {
        super(props);

        this.state = { keywords: props.initialKeyword ?? "" }
    }

    private searchAction: null | ReturnType<typeof setTimeout> = null
    public keywordEntered(keywords: string) {
        this.setState({ keywords: keywords });

        if (this.searchAction) {
            clearTimeout(this.searchAction);
        }

        this.searchAction = setTimeout(() => {
            this.setState({ keywords }, () => {
                this.props.onSearch(this.state.keywords);
            });
        }, 300);
    }

    componentWillUnmount() {
        if (this.searchAction) {
            clearTimeout(this.searchAction);
        }
    }

    public resetKeywords() {
        this.props.onSearch("");
        this.setState({ keywords: "" })

    }

    private handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        this.props.onSearch(this.state.keywords);
    }


    public render() {
        return (
            <form
                onSubmit={(e) => this.handleSubmit(e)}
                onReset={() => this.resetKeywords()}
                className="d-flex justify-content-between align-items-stretch flex-column flex-md-row">
                <div className="flex-grow-1 mr-1 d-flex align-items-stretch mb-2 mb-md-0" role="search">
                    <div className="custom-search w-100 p-1px">
                        <label className="sr-only">{this.props.placeholderText}</label>
                        <input type="text"
                            className="custom-search-input form-control"
                            value={this.state.keywords}
                            onChange={(event: any) => { this.keywordEntered(event.target.value) }}
                            placeholder={this.props.placeholderText}></input>
                        {
                            (this.state.keywords.length > 0)
                                ? <button type="reset"
                                    className="custom-search-reset d-flex align-items-center btn btn-link"
                                    aria-label="clear search term">
                                    <img src="/img/svg/icon-x.svg" alt="" />
                                </button>
                                : null
                        }
                    </div>
                </div>
                <button type="submit" className="btn btn-primary ml-md-2 btn-text-lg" >
                    {this.props.searchButtonText}
                </button>
            </form>
        );
    }
}